export default "__VITE_ASSET__DexLJkUH__"